import React from 'react'
import './Dropdown.css'
import Carot from './carot.svg'
import { Link } from 'react-router-dom'

const linkStyle = {
  margin: "0rem 24px 0rem 24px",
  textDecoration: "none",
  color: 'white',
  fontSize: "12px",
};

export default function Dropdown() {
  return (
    <div>
      <div className='topics'>
      <Link to = "/js" style={linkStyle}><h1>Javascript</h1></Link>
            <div class="dropdown">
              <button class="dropbtn">Lessons 
              <img src= {Carot} />
              </button>
              <div class="dropdown-content">
                  <h4>Module 1: Get Started</h4>  
                  <a href="#">1. Introduction</a>
                  <a href="#">2. Development Tools</a>
                  <a href="#">3. Introduction to chrome dev tools</a>
                  <a href="#">4. Add JS to web page : Inline</a>
                  <a href="#">5. Add JS to web page : Internal</a>
                  <a href="#">6. Add JS to head or body</a>
                  <a href="#">7. Our first Javascript code</a>
                  <a href="#">8. Javascript output</a>
                  <a href="#">9. Variables</a>
                  <a href="#">10. Data types</a>
                  <a href="#">11. Expression</a>
                  <a href="#">12. Arithmetic operators</a>
                  <a href="#">13. Type conversion and Typeof</a>
                  <a href="#">14. String operators</a>
                  <a href="#">15. Boolean</a>


                  <h4>Module 2: Control Structures</h4>  
                  <a href="#">1. If and if else statements</a>
                  <a href="#">2. Comparison Operators</a>
                  <a href="#">3. Logical Operators + Ternaries</a>
                  <a href="#">4. switch</a>
                  <a href="#">5. for</a>
                  <a href="#">6. while</a>
                
                  <h4>Module 3: Functions & Data Structures</h4>  
                  <a href="#">1. What is a function?</a>
                  <a href="#">2. Function Declaration</a>
                  <a href="#">3. Calling a function</a>
                  <a href="#">4. More ways to make functions</a>
                  <a href="#">5. Function parameters</a>
                  <a href="#">6. Scope : Global and Local</a>
                  <a href="#">7. Function hoisting</a>
                  <a href="#">8. Variables : const keyword</a>
                  <a href="#">9. Function Experssion</a>
                  <a href="#">10. Anonymous Function</a>
                  <a href="#">11. Constructor function</a>
                  <a href="#">12. Nested functions and closures</a>
                  <a href="#">13. What is array?</a>
                  <a href="#">14. Create an Array</a>
                  <a href="#">15. Access & change Array elements</a>
                  <a href="#">16. Add a new element to array</a>
                  <a href="#">17. Objects</a>
                  <a href="#">18. Creating new objects</a>
                  <a href="#">19. Accessing object properties</a>
                  <a href="#">20. Object Methods</a>
                  <a href="#">21. this Keyword</a>

                  <h4>Module 4: Document Object Model & Events</h4>  
                  <a href="#">1. What is DOM ?</a>
                  <a href="#">2. DOM tree</a>
                  <a href="#">3. Selecting HTML Elements</a>
                  <a href="#">4. Changing HTML Elements</a>
                  <a href="#">5. Modifying CSS</a>
                  <a href="#">6. What are Events ?</a>
                  <a href="#">7. Mouse click</a>
                  <a href="#">8. Event Listner</a>
                  <a href="#">9. Web page loading</a>
                  <a href="#">10. Form submission</a>
                  
              </div>
            </div> 
      </div>
    </div>
  )
}
